module.exports = __webpack_public_path__ + "static/kalejaiye-5047018534260e89324218a58b6a63cd.png";